import { useEffect, useState } from 'react';

import Base from '../../../utils/base'
import CustomTable from '../../../layout/custom_table/index'

export default function Province() {
  var base = new Base()
  const [arr_header, set_arr_header] = useState([
    {
      label: base.i18n.t('name'),
      data: 'name',
    },
    {
      label: base.i18n.t('country'),
      data: 'country_name',
    },
  ])
  const [arr, set_arr] = useState([])

  function on_update_data(arr){
    arr.forEach((data, index) => {
      data.country_name = data.country.name
    })
    set_arr(arr)
  }

  return (
    <div>
      <h3>{base.i18n.t('province')}</h3>
      <CustomTable 
        url='/province' 
        arr_header={arr_header} 
        arr={arr} 
        url_update='/province/action'
        url_create='/province/action'
        url_delete='/province'
        on_update_data={data => on_update_data(data)}/>
    </div>
  );
}